import React, { createContext, useContext } from "react";
import NewsletterRecaptcha from "../commons/newsletter-recaptcha";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useAppContext } from "./app-context";

const NewsletterFormCtx = createContext();

export function useNewsletterFormCtx() {
  const context = useContext(NewsletterFormCtx);
  if (context === undefined) {
    throw new Error(
      "useNewsletterFormCtx must be used within an NewsletterFormProvider"
    );
  }
  return context;
}

export function NewsletterFormProvider({ children }) {
  const app = useAppContext();
  const [isOpenRecaptcha, setIsOpenRecaptcha] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const { handleSubmit, control, getValues, reset } = useForm({
    defaultValues: {
      email: "",
    },
    mode: "onChange",
  });
  const onRecaptchaSuccess = async (recaptchaCode) => {
    setIsOpenRecaptcha(false);
    setLoading(true);

    const formData = getValues();
    const postData = {
      formId: 4,
      "g-recaptcha-response": recaptchaCode,
      data: {
        ...formData,
      },
    };

    try {
      const response = await axios.post(
        "https://workflow.geronaalvin.com/webhook/29c3e741-1a32-4664-8da5-9375bc9f1667",
        postData
      );

      if (response.data.message) {
        setSuccess(true);
        app.successModal.open(
          "Newsletter Subscription",
          "Thank you for subscribing to our newsletter! We will keep you updated with the latest news and offers."
        );
      }

      reset();
    } catch (error) {
      console.error("Error sending contact form:", error);
    }

    setLoading(false);
  };

  const onSubmit = async () => {
    if (loading) {
      return;
    }

    setIsOpenRecaptcha(true);
    setLoading(true);
  };

  React.useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [success, reset]);

  const value = {
    loading,
    success,
    control,
    onSubmit: handleSubmit(onSubmit),
    recaptcha: {
      isOpenRecaptcha,
      onRecaptchaSuccess,
      setIsOpenRecaptcha,
    },
  };

  return (
    <NewsletterFormCtx.Provider value={value}>
      {children}
      <NewsletterRecaptcha />
    </NewsletterFormCtx.Provider>
  );
}
